import { usePropertyNumberUnits } from '../../../../../queries/PropertyFields/NonRentalCoreFields';
import { DropDownBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface UnitsDropDownProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const UnitsDropDown: React.FC<UnitsDropDownProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Units';
    const [numberUnits, set_numberUnits] = usePropertyNumberUnits(propertyGuid);

    // generate options 5..35
    const numberUnitsValues = [
        { display: '', value: '' },
        ...[...Array.from(Array(31).keys())]
            .map((x) => x + 5)
            .map((count) => {
                return {
                    display: count.toString(),
                    value: count,
                };
            }),
    ];

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={numberUnits}
                />
            ) : (
                <DropDownBox
                    id='numberNonRentalUnits'
                    value={numberUnits}
                    onChange={(value) => set_numberUnits(value)}
                    label={label}
                    required={true}
                    dataSource={numberUnitsValues}
                    valueExpr='value'
                    displayExpr='display'
                />
            )}
        </>
    );
};
